/** Valida fechas sin depender del parsing permisivo de JavaScript/Day.js. */
export const esFechaISOValida = (value) => {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const [year, month, day] = value.split('-').map(Number);
  if (year < 1 || month < 1 || month > 12 || day < 1) return false;
  const isLeapYear = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  const daysInMonth = [31, isLeapYear ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  return day <= daysInMonth[month - 1];
};

/** Importe opcional; si se carga, debe ser numérico, finito y no negativo. */
export const validarImporte = (value, { obligatorio = false } = {}) => {
  if (value === '' || value === null || value === undefined) {
    return obligatorio ? { ok: false, value: null } : { ok: true, value: null };
  }
  const normalized = String(value).trim();
  if (!normalized) return obligatorio ? { ok: false, value: null } : { ok: true, value: null };
  const number = Number(normalized);
  return { ok: Number.isFinite(number) && number >= 0, value: number };
};
